import { Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-24);

  ${Input.S.Input} {
    min-width: 370px;
  }

  .action-buttons {
    bottom: -8px !important;
    right: 12px !important;
  }
`;
